'use strict';

var jsxRuntime = require('react/jsx-runtime');

const MediumLink = ({ testId, className })=>{
    return jsxRuntime.jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        "data-testid": testId,
        className: className,
        children: [
            jsxRuntime.jsx("path", {
                d: "M5.73242 3.4065L6.72358 2.41534C8.6107 0.52822 11.6976 0.52822 13.5847 2.41534C15.4718 4.30246 15.4718 7.38933 13.5847 9.27645L12.5935 10.2676",
                stroke: "currentColor",
                strokeWidth: "1.4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M10.2676 12.5933L9.27645 13.5844C7.38933 15.4716 4.30246 15.4716 2.41534 13.5844C0.52822 11.6973 0.52822 8.61046 2.41534 6.72334L3.4065 5.73218",
                stroke: "currentColor",
                strokeWidth: "1.4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M10.4427 5.55707L5.55688 10.4429",
                stroke: "currentColor",
                strokeWidth: "1.4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

module.exports = MediumLink;
